function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.8999 5.68479C10.8999 5.22755 10.8628 4.89388 10.7825 4.54785H5.56122V6.61164H8.62602C8.56425 7.12452 8.23058 7.89691 7.48908 8.41592L7.47868 8.48501L9.12957 9.76393L9.24394 9.77535C10.2944 8.80522 10.8999 7.37785 10.8999 5.68479",
  fill: "#4285F4"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.56113 11.1223C7.06262 11.1223 8.32314 10.6279 9.24386 9.77526L7.48899 8.41584C7.01939 8.74333 6.38911 8.97195 5.56113 8.97195C4.09052 8.97195 2.84236 8.00187 2.39742 6.66101L2.3322 6.66655L0.615589 7.99505L0.59314 8.05746C1.50763 9.87409 3.38608 11.1223 5.56113 11.1223Z",
  fill: "#34A853"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M2.39746 6.66102C2.28006 6.315 2.21211 5.94422 2.21211 5.56114C2.21211 5.17801 2.28006 4.80728 2.39128 4.46126L2.38817 4.38756L0.650045 3.03772L0.593177 3.06477C0.21627 3.81863 0 4.66518 0 5.56114C0 6.4571 0.21627 7.30361 0.593177 8.05747L2.39746 6.66102",
  fill: "#FBBC05"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M5.56113 2.1503C6.60538 2.1503 7.30978 2.60137 7.71144 2.97832L9.28092 1.4459C8.31701 0.54994 7.06262 0 5.56113 0C3.38608 0 1.50763 1.24816 0.59314 3.0648L2.39124 4.46129C2.84236 3.12043 4.09052 2.1503 5.56113 2.1503",
  fill: "#EB4335"
});

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.01a5e05c.svg";
export { ForwardRef as ReactComponent };